module.exports = __webpack_public_path__ + "img/search.875d575e.svg";